// Theme Configuration
// Change the DEFAULT_THEME value to set the app's initial theme

export const THEME_CONFIG = {
  // Options: 'light', 'dark', or 'system'
  // 'light' - Always start with light theme
  // 'dark' - Always start with dark theme  
  // 'system' - Follow user's system preference (default behavior)
  DEFAULT_THEME: 'light'
};

export default THEME_CONFIG; 